import { DataValveCDMEvent } from '@jarvis/shell-commons/dist/interface/v1/analytics/types'

import { EventDispatcherConfig, ActionEventDetails } from '../types'

import { SIMPLE_UI_EVENT } from '@/constants/analytics'

/**
 * Spec: {@link https://rndwiki.inc.hpicorp.net/confluence/spaces/CDM/pages/1290961929/simpleUi+Category, Simple Ui event}
 */
export function buildSimpleUiEvent(
  eventDispatcherConfig: EventDispatcherConfig,
  eventDetail: ActionEventDetails,
): DataValveCDMEvent[] {
  /**
   * Hierarchy of how event details is built:
   * 1. Specific event details associated with dispatched action, `eventDetails`, which includes `action` attribute. These can override any attribute set by analytics manifest
   * 2. Configuration set when analytics manifest is first created, see {@link createAnalyticsManifest}
   *    - Default event details associated with multiple events, `defaultData`, which does not conflict with main configuration event detail
   *    - Configuration event details, `config`, which includes mandatory event attributes such as `activity`, `screenName`, and `screenPath`
   */
  const unifiedEventDetails = {
    ...eventDispatcherConfig.config,
    ...eventDispatcherConfig.defaultData,
    ...eventDetail,
  }

  return [
    {
      eventDetail: {
        ...unifiedEventDetails,
        actionAuxParams: unifiedEventDetails.actionAuxParams?.toString?.(),
        version: SIMPLE_UI_EVENT.VERSION,
      },
      dateTime: new Date().toISOString(),
      eventDetailType: SIMPLE_UI_EVENT.EVENT_DETAIL_TYPE,
      eventCategory: SIMPLE_UI_EVENT.EVENT_CATEGORY,
      version: SIMPLE_UI_EVENT.ENVELOPE_VERSION,
    },
  ]
}
